import { createContext, useContext } from 'react';

/**
 * True when MSAL initialized successfully and the auth-aware hooks are safe to
 * call. False when `/appsettings.json` has no usable OIDC config, in which case
 * there is no `MsalProvider` above us.
 */
export const AuthAvailabilityContext = createContext(false);

export function useAuthAvailable(): boolean {
  return useContext(AuthAvailabilityContext);
}
